export default "__VITE_ASSET__BHH$7aYN__"